export const UTM_KEYS = [
  'utmSource',
  'utmCampaign',
  'utmMedium',
  'utmTerm',
  'utmContent',
  'utmAdgroup',
  'utmKeywordId',
  'utmMatchType',
  'gclid',
  'utmAssetGroup',
  'utmPlacement',
  'reentrySource',
] as const;

export const EXTENDED_UTM_KEYS = [
  ...UTM_KEYS,
  'initialUtmCampaign',
  'initialUtmSource',
  'initialUtmMedium',
  'initialUtmTerm',
  'initialUtmContent',
  'initialUtmAdgroup',
  'initialUtmKeywordId',
  'initialUtmMatchType',
  'initialGclid',
  'initialUtmAssetGroup',
  'initialUtmPlacement',
] as const;

export const UTM_REENTRY_SOURCE_COOKIE_KEY = 'reentry_source';

export const UTM_SOURCE_COOKIE_KEY = 'utm_source';
